const initialState = {
    accessToken: null,
    authToken: null,
    accountType: 'custom',
    isAuth: false,
    splash: false,
    apolloAuth: null,
  };
  export default (state = initialState, actions) => {
    switch (actions.type) {
      case 'UPDATE_TOKENS':
        return {
          ...state,
          ...actions.payload,
        };
      case 'LOCAL_STORAGE_TOKEN':
        return {
          ...state,
          ...actions.payload,
        };
      case "LOGOUT":
        return {};
      default:
        return state;
    }
  };